<template>
  <a-modal
    v-model:open="visible"
    :width="width"
    :height="height"
    wrapClassName="shandong-create-modal"
    :footer="null"
    destroy-on-close
    :mask-closable="true"
    @cancel="onClose"
  >
    <div class="title">
      <iconpark-icon v-if="icon" name="circle-check" class="text-success-6" />
      {{ title }}
    </div>
    <div class="mt-[16px]">
      <slot name="content"></slot>
    </div>
  </a-modal>
</template>

<script lang="ts" setup>
const props = defineProps<{
  width: number
  height: number
  title: string
  icon?: boolean
}>()

const $emit = defineEmits(['close'])

const visible = ref(false)

const toggleShow = () => {
  visible.value = !visible.value
}

const onClose = () => {
  visible.value = false
  $emit('close')
}

defineExpose({
  toggle: toggleShow,
})
</script>

<style lang="scss">
.shandong-create-modal {
  .ant-modal-content {
    padding: 20px;
    padding-top: 15px;
    background: linear-gradient(180deg, #ffe9dc 0%, #fff9eb 100%);
  }
  .ant-modal-close {
    top: 22px;
  }
  .title {
    @apply text-[24px] text-center text-font-1 flex-y-center justify-center gap-[12px];
    font-weight: 600;
    background: linear-gradient(
      26.601287523822155deg,
      #ff845d 0%,
      #cf3e08 100%
    );
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
}
</style>
